export default "__VITE_ASSET__BJB78Zz6__"